<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Pedidos</h3>
            </div>
            <div class="col-auto">
              <b-button v-if="isVendedor" variant="outline-dark" download="pedidos.xls" :href="`${baseURL}/api/saude/export-xls?empresa=${empresa._id}&id=${user._id}`">
                <i class="fas fa-file-excel"></i> Exportar
              </b-button>
              <b-button v-else variant="outline-dark" download="pedidos.xls" :href="`${baseURL}/api/saude/export-xls?empresa=${empresa._id}`">
                <i class="fas fa-file-excel"></i> Exportar
              </b-button>
              <b-button v-if="(isAdministrador || isVendedorMaster) && isUtilizaPlataformaPagamento" :download="`transacoes-${empresa.name}.xls`"
                :href="`${baseURL}/api/saude/fatura-xls-empresa?idEmpresa=${empresa._id}`">
                <i class="fas fa-file-excel"></i> Exportar Pagamentos
              </b-button>
            </div>
          </div>
        </div>

        <div class="">
          <div class="text-right">
            <b-button v-b-toggle.collapse-1 variant="primary">
              <i class="fa fa-filter"></i>
              Filtros
            </b-button>
          </div>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card header="Filtros para aplicar">
              <div class="container">
                <div class="row">
                  <div class="col-3">
                    <div class="form-group">
                      <label>Id Pedido</label>
                      <input type="cel" class="form-control" v-model="filtro.idPedidoVindi">
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group" :class="{'has-danger': errors.has('cpf')}">
                      <label>CPF Cliente</label>
                      <input type="cel" class="form-control"
                        id="cpf" name="cpf"
                        v-mask="'###.###.###-##'"
                        v-validate="'cpf'"
                        v-model="filtro.cpfCliente">
                      <div
                        v-if="errors.has('cpf')"
                        class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('cpf')}}</div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <label>NRº Cartão</label>
                      <input type="cel" class="form-control" v-model="filtro.numeroCartao">
                    </div>
                  </div>
                </div>
                  <div class="row">
                    <div class="col-3">
                      <div class="form-group">
                        <label>Data Inicio Pedido</label>
                        <datepicker calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button v-model="filtro.dataInicioPedido"></datepicker>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-group">
                        <label>Data fim Pedido</label>
                        <datepicker calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button v-model="filtro.dataFimPedido"></datepicker>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label>Nome Cliente</label>
                        <input v-model="filtro.nomeCliente" type="text" class="form-control">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label>Forma Pagamento</label>
                        <multiselect v-model="filtro.formasPagamento" :multiple="true"
                          :taggable="true" :options="formasPagamento" :showLabels="false"
                          :hide-selected="true" select-label="" label="name" value="code" track-by="code"
                          :searchable="false" placeholder="Selecione a forma de pagamento"></multiselect>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label>Status Pedido</label>
                        <multiselect v-model="filtro.statusPedido" :multiple="true"
                          :taggable="true" :options="statusPedido" label="name" value="code" track-by="code"
                          :hide-selected="true" :showLabels="false"
                          :searchable="false" placeholder="Selecione o status do pedido"></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="row text-right">
                    <div class="col">
                      <b-link @click="limpar" class="mr-2">Limpar</b-link>
                      <b-button v-b-toggle.collapse-1 @click="find" variant="primary">Aplicar</b-button>
                    </div>
                  </div>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <div class="mt-3">
          <b-card>
              <div class="row">
                <b-col class="my-1">
                  <b-pagination
                    v-if="totalRows > 10"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </div>
              <b-table show-empty emptyText="Não há itens para exibir"
              ref="table" id="my-table"
              :current-page="currentPage"
              :per-page="perPage" selectable
              @row-selected="onRowSelected"
              select-mode="single"
              selected-variant="success"
              :busy="loading" :items="pedidos" sticky-header
              :fields="isUtilizaPlataformaPagamento ? fields : fieldsSemPlataformaPgt" small
              striped hover bordered>
                <div slot="table-busy" class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Carregando...</strong>
                </div>
                <template class="text-center" slot="[vads_trans_status]" slot-scope="row">
                  <b-badge :variant="getTextStatusPagamento(row.item.vads_trans_status) === 'Pago' ? 'success' : 'warning'">{{getTextStatusPagamento(row.item.vads_trans_status)}}</b-badge>
                </template>
                <template slot="[formadePagamento]" slot-scope="row">
                  <b-badge variant="warning">{{getTextFormaPagamento(row.item.formadePagamento)}}</b-badge>
                </template>
                <template slot="[plano]" slot-scope="row">
                 {{row.item.plano.name}} - {{row.item.plano.price | money }}
                </template>
                <template slot="[actions]" slot-scope="row">
                  <b-button title="Visualizar" variant="light" @click.stop=" $router.push({name: 'PedidoDetail', query:{id: row.item._id}})">
                    <i class="fas fa-search"></i>
                  </b-button>
                </template>
              </b-table>
          </b-card>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import _ from 'lodash';

import { Validator } from "vee-validate";
import utils from "@/utils";

export default {
  created() {
    Validator.extend("cpf", {
      getMessage: () => "CPF inválido",
      validate: value => {
        return !!utils.TestaCPF(value);
      }
    });
  },
  components: {
    datepicker,
    Multiselect
  },
  data () {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      items: [],
      fields: [
        {key: 'vads_trans_status', class: 'text-center', label: 'Status'},
        {key: 'createdAt', label: 'Data Criação', sortable: true, formatter: this.createdAtFormatter},
        {key: 'dataVencimentoFatura', label: 'Vencimento Ultima Fatura', sortable: true, formatter: this.createdAtFormatter},
        {key: 'idPedidoVindi', label: 'ID', sortable: true},
        {key: 'client.cpf', label: 'CPF'},
        {key:'client.name', label: 'Nome'},
        {key: 'plano', label: 'Plano', sortable: true},
        {key: 'formadePagamento', label: 'Método Pagamento'},
        {key: 'actions', label: ''}],
      fieldsSemPlataformaPgt: [
        {key: 'cartao[0].status', class: 'text-center', label: 'Status'},
        {key: 'createdAt', label: 'Data Criação', sortable: true, formatter: this.createdAtFormatter},
        {key: 'idPedidoVindi', label: 'ID', sortable: true},
        {key: 'client.cpf', label: 'CPF'},
        {key:'client.name', label: 'Nome'},
        {key: 'plano', label: 'Plano', sortable: true},
        {key: 'cartao[0].numeroCartao', label: 'Cartão', formatter: this.formatarNrCartao},
        {key: 'actions', label: ''}],
      formasPagamento: [{code: 'Boleto', name: 'Boleto'}, {code: 'carne', name: 'Carnê'}, {code: 'cartaoCredito', name: 'Cartão Crédito'}, {code: 'dinheiro', name: 'Dinheiro'}],
      statusPedido: [{code: 'paid', name: 'Pago'}, {code: 'Inadimplente', name: 'Inadimplente'}, {code: 'Cancelado', name: 'Cancelado'}, {code: 'waiting', name: 'Aguardando pagamento'}, {code: 'rejected', name: 'Rejeitado'}, {code: 'failure', name: 'Falha'}, {code: 'processing', name: 'Processando'}],
      filtro:{
        formasPagamento: null,
        statusPedido: null
      }
    }
  },
  computed: {
    baseURL(){
      return axios.defaults.baseURL;
    },
    loading() {
      return this.$store.getters.loadingTable;
    },
    empresa() {
      return this.$store.getters.empresa;
    },
    isUtilizaPlataformaPagamento() {
      return this.$store.getters.empresa.utilizaPlataformaPagamento;
    },
    isVendedor() {
      return this.$store.getters.isVendedor;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    },
    isVendedorMaster() {
      return this.$store.getters.isVendedorMaster;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  watch:{
    empresa() {
      this.$root.$emit('bv::refresh::table', 'my-table')
    }
  },
  methods: {
    formatarNrCartao(value){
      if (!value) return '';
      return value.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/ig, '$1 $2 $3 $4');
    },
    limpar() {
      this.filtro = {
        formasPagamento: null,
        statusPedido: null
      };
    },
    async find() {
      this.$store.dispatch("setLoadingTable", true);
      this.$root.$emit('bv::refresh::table', 'my-table')
      this.$store.dispatch("setLoadingTable", false);
    },
    createdAtFormatter(value){
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
      return ''
    },
    pedidos(ctx) {
      const filtro = _.cloneDeep(this.filtro);
      if (this.isVendedor) {
        filtro.vendedor = this.user._id;
      }
      if (filtro.formasPagamento) {
        filtro.formasPagamento  = filtro.formasPagamento.map(fp => fp.code);
      }
      if (filtro.statusPedido) {
        filtro.statusPedido = filtro.statusPedido.map(st => st.code);
      }
      if (filtro.numeroCartao) {
        filtro.numeroCartao = filtro.numeroCartao.replace(/[ ]/ig,'');
      }
      if(filtro.dataInicioPedido || filtro.dataFimPedido){
        filtro.dataInicioPedido=this.createdAtFormatter(filtro.dataInicioPedido)
        filtro.dataFimPedido=this.createdAtFormatter(filtro.dataFimPedido)
      }
      // eslint-disable-next-line
      console.log(filtro.empresa)
      filtro.empresa = this.empresa._id;
      filtro.limit = ctx.perPage;
      filtro.page = ctx.currentPage;

      this.currentPage = ctx.currentPage;

      const promise = axios.get('/api/saude/findWriteLabel', {
        params: filtro
      });
      return promise.then(response => {
        let result = response.data;
        this.totalRows = result.totalCount;

        const items = result.data;
        return items || []
      });
    },
    onRowSelected(items) {
      let pedido = items[0];
      this.$router.push({name: 'PedidoDetail', query:{id: pedido._id}});
    },
    getTextStatusPagamento(statusVindi) {
      switch (statusVindi) {
        case 'processing':
          return 'Processando pagamento'
        case 'failure':
          return 'Falha ao processar pagamento'
        case 'rejected':
          return 'Pagamento rejeitado'
        case 'waiting':
          return 'Aguardando pagamento'
        case 'success':
        case 'paid':
          return 'Pago'
        default:
          return statusVindi
      }
    },
    getTextFormaPagamento(formaPagamento) {
      switch (formaPagamento) {
        case 'cartaoCredito':
          return 'Cartão Crédito'
        default:
          return formaPagamento;
      }
    },
  }

}
</script>
<style scoped>
.b-table-sticky-header {
  overflow-y: auto;
  max-height: none;
}
</style>
